<script setup>
import { ref, computed } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { useRouter, useRoute } from 'vue-router';
import wootConstants from 'dashboard/constants/globals';
import ContactsCard from 'dashboard/components-next/Contacts/ContactsCard/ContactsCard.vue';
import { buildContactDetailsRoute } from 'dashboard/routes/dashboard/contacts/helpers/contactRouteHelper';

const props = defineProps({
  contacts: { type: Array, required: true },
  selectedContactIds: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['toggleContact']);

const router = useRouter();
const route = useRoute();
const { width: windowWidth } = useWindowSize();

const isMobile = computed(
  () => windowWidth.value < wootConstants.SMALL_SCREEN_BREAKPOINT
);
const hoveredAvatarId = ref(null);

const selectedIdsSet = computed(() => new Set(props.selectedContactIds || []));

const onClickViewDetails = async id => {
  await router.push(buildContactDetailsRoute(route, id));
};

const isSelected = id => selectedIdsSet.value.has(id);

const shouldShowSelection = id => {
  return hoveredAvatarId.value === id || isSelected(id);
};

const handleSelect = (id, value) => {
  emit('toggleContact', { id, value });
};

const handleAvatarHover = (id, isHovered) => {
  hoveredAvatarId.value = isHovered ? id : null;
};
</script>

<template>
  <div class="flex flex-col">
    <div
      v-for="contact in contacts"
      :key="contact.id"
      class="relative mx-1 border-b border-n-weak/50 last:border-b-0 dark:border-n-weak/40 md:mx-0"
    >
      <ContactsCard
        :id="contact.id"
        :name="contact.name"
        :email="contact.email"
        :thumbnail="contact.thumbnail"
        :phone-number="contact.phoneNumber"
        :tier="contact.additionalAttributes?.tier"
        :availability-status="contact.availabilityStatus"
        :selectable="!isMobile && shouldShowSelection(contact.id)"
        :is-selected="!isMobile && isSelected(contact.id)"
        @show-contact="onClickViewDetails"
        @select="value => handleSelect(contact.id, value)"
        @avatar-hover="value => handleAvatarHover(contact.id, value)"
      />
    </div>
  </div>
</template>
